module.exports = __webpack_public_path__ + "img/purchase-ticket.6366d807.svg";